import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { AuthorizedAppsStore } from 'pages/settings/pages/developer/pages/authorizedApps/store/authorizedAppsStore'

export const AuthorizedAppsViewContext = createContext<AuthorizedAppsStore | null>(null)

export const useAuthorizedAppsViewContext = () => {
  const context = useContext(AuthorizedAppsViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AuthorizedAppsViewContext')

  return context
}

export const AuthorizedAppsViewProvider = ({ children }: PropsWithChildren) => {
  const store = useMemo(() => new AuthorizedAppsStore(), [])

  useEffect(() => {
    void store.init()
    return () => store.dispose()
  }, [store])

  return (
    <AuthorizedAppsViewContext.Provider value={store}>
      {children}
    </AuthorizedAppsViewContext.Provider>
  )
}
